import React from 'react';

import { useLang, useMediaConfigSearch } from 'bdvp-common/src/hooks/config';

import MessageComponent from '../components/Message';

const defaultMessage = {
    title: '',
    body: '',
};

const Message = ({
    type,
}) => {

    const lang = useLang();
    const { messages = {} } = useMediaConfigSearch();

    const message = messages[type]?.[lang] ?? defaultMessage;

    return (
        <MessageComponent
            message={message}
        />
    );

};

export default Message;
